<div class="mt-0 text-[12px] text-error">
  @if (shouldShowErrors() && actualControl?.errors) {
    @for (error of errorEntries; track error.key) {
      <p>{{ getErrorMessage(error.key, error.value) }}</p>
    }
  }
</div>
